function NativicationsAr(){
    return (
        <>
        <div className="nativ" dir="rtl">
            <div className="icon">
            <i className="fa-solid fa-circle-check"></i>
            </div>
            <div className="massage">
                <p>تم تحديث سيرتك ذاتية </p>
            </div>
        </div>
        </>
    )
}


export default NativicationsAr